import { sortVariants } from "./utils";

function fillProduct(product) {
  // Build product card from template
  const productTemplate = document.querySelector('#predictive-search-relewise-product-template');
  const productCard = productTemplate.content.cloneNode(true);
  const imageSrc = product.data?.['intersport-dk.myshopify.com_ImageUrls']?.value?.$values[0] ? product.data?.['intersport-dk.myshopify.com_ImageUrls']?.value?.$values[0] + "&width=400" : "";
  const secondaryImageSrc = product.data?.['intersport-dk.myshopify.com_ImageUrls']?.value?.$values[1] ? product.data?.['intersport-dk.myshopify.com_ImageUrls']?.value?.$values[1] + "&width=400" : "";
  const productID = 'gid://shopify/Product/' + product.data?.productID;
  const handle = product.data?.['intersport-dk.myshopify.com_ShopifyHandle']?.value;
  const vendor = product.data?.Vendor?.value;
  const genders = product.data?.['intersport-dk.myshopify.com_custom.kon']?.value?.$values;

  if (!handle || !productID) { console.log('Missing data for product', product); return; }

  // bazaarvoice 
  if (productCard.querySelector('bazaarvoice-inline-rating div')) {
    productCard.querySelector('bazaarvoice-inline-rating div').setAttribute('data-bv-product-id', product.data?.productID);
    productCard.querySelector('bazaarvoice-inline-rating div').setAttribute('data-bv-redirect-url', '/products/' + handle);
  }

  // product genders 
  if (genders || genders > 0) genders.forEach((gender, index) => {
    const genderContainer = productCard.querySelector('.genders');
    if (index > 0) {
      const spanDot = document.createElement('span');
      spanDot.textContent = ' · ';
      genderContainer.appendChild(spanDot);
    }
    const spanElm = document.createElement('span');
    spanElm.textContent = gender;
    genderContainer.appendChild(spanElm);
  });

  // links
  productCard.querySelector('.product-card-image-link').href = '/products/' + handle;
  productCard.querySelector('.product-card-title').href = '/products/' + handle;

  // images
  productCard.querySelector('.product-card-main-image img').src = imageSrc ? imageSrc : "";
  productCard.querySelector('.product-card-secondary-image img').src = secondaryImageSrc ? secondaryImageSrc : "";
  if (!secondaryImageSrc || secondaryImageSrc === "") {
    productCard.querySelector('.product-card-secondary-image').remove();
    productCard.querySelector('.product-card-image-link').classList.remove('has-secondary-image');
  }
  // preload secondary image
  if (secondaryImageSrc && secondaryImageSrc !== "") {
    const img = new Image();
    img.src = secondaryImageSrc;
  }

  // text + price 
  const productDisplayName = product.displayName.replace('·', '<span class="text-accent">·</span>');
  // Compare at price
  let listPrice = product.listPrice;

  // Standard price
  let salesPrice = product.salesPrice;

  let membershipPricingEnabled = false;
  if (product.data?.['intersport-dk.myshopify.com_custom.membership_pricing_enabled']) {
    if (product.data['intersport-dk.myshopify.com_custom.membership_pricing_enabled'].value) membershipPricingEnabled = true;
  }
  if (relewiseData.labels.memberPrice.enable && membershipPricingEnabled) productCard.querySelector('.member-price-text').classList.remove('opacity-0');

  productCard.querySelector('.product-card-title').textContent = vendor + ' - ' + productDisplayName;
  productCard.querySelector('.product-card-price-wrapper .current-price').textContent = salesPrice + ' ' + relewiseData.current_currency_symbol;
  if (salesPrice < listPrice) {
    productCard.querySelector('.product-card-price-wrapper .compare-price').textContent = listPrice + ' ' + relewiseData.current_currency_symbol;
  } else {
    productCard.querySelector('.product-card-price-wrapper .current-price').classList.remove('text-accent');
    productCard.querySelector('.product-card-price-wrapper del').remove();
  }

  // variants
  const variantWrapper = productCard.querySelector('[data-swatches-and-sizes] .size-options');

  const sortedVariants = sortVariants(product.allVariants);

  if (variantWrapper) {
    sortedVariants.forEach(variant => {
      const sellableOnline = variant.data['intersport-dk.myshopify.com_SellableOnlineQuantity']?.value;
      if (!(sellableOnline > 0)) return;
      const variantElement = document.createElement('p');
      variantElement.textContent = variant.displayName;
      variantElement.classList.add('whitespace-nowrap', 'text-2-medium');
      variantWrapper.appendChild(variantElement);
    });
    let moreSizesElement = document.createElement('p')
    moreSizesElement.classList.add('more-sizes', 'text-2-medium');
    moreSizesElement.textContent = '+';
    variantWrapper.appendChild(moreSizesElement);
  }

  // LABELS
  const labelWrapper = productCard.querySelector('.labels');
  const labelClasses = "px-1 sm:px-2 pt-[3] pb-[4.2] text-badge uppercase";
  const discountPercentage = Math.round((product.listPrice - product.salesPrice) / product.listPrice * 100);
  // sale label
  if (relewiseData.labels.sale.enable && discountPercentage > 0) {
    const saleLabel = document.createElement('span');
    const colorSchemeClass = 'color-' + relewiseData.labels.sale.colorScheme;
    saleLabel.textContent = '-' + discountPercentage + '%';
    saleLabel.classList.add(...labelClasses.split(' '), colorSchemeClass);
    labelWrapper.appendChild(saleLabel);
  }
  // sold out label
  if (relewiseData.labels.soldout && product.data?.inStock?.value == false) {
    const soldOutLabel = document.createElement('span');
    const colorSchemeClass = 'color-' + relewiseData.labels.soldout.colorScheme;
    soldOutLabel.textContent = relewiseData.labels.soldout.text;
    soldOutLabel.classList.add(...labelClasses.split(' '), colorSchemeClass);
    labelWrapper.appendChild(soldOutLabel);
  }
  //  member price label 
  if (relewiseData.labels.memberPrice.enable && membershipPricingEnabled) {
    const memberPriceLabel = document.createElement('span');
    memberPriceLabel.textContent = relewiseData.labels.memberPrice.text;
    memberPriceLabel.classList.add(...relewiseData.labels.memberPrice.classes.split(' '));
    labelWrapper.appendChild(memberPriceLabel);
  }
  // custom labels
  product.data?.['intersport-dk.myshopify.com_custom.custom_labels']?.value?.$values.forEach(labelID => {
    const label = relewiseData?.labels?.customLabels.find(label => label.id.toString() === labelID.toString());
    if (label) {
      const customLabel = document.createElement('span');
      customLabel.textContent = label.title;
      customLabel.classList.add(...labelClasses.split(' '), 'text-background');
      customLabel.style.backgroundColor = label.color;
      labelWrapper.appendChild(customLabel);
    }
  });

  // connected products 
  productCard.querySelector('[data-swatches-and-sizes] .swatches').remove();
  return productCard;
}

export default fillProduct;